// ! This file was auto-generated from the hermes OpenAPI schema. Do not override this file.
export const Tags = {
    conversations: "conversations",
    notifications: "notifications"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
